import styled from 'styled-components'
import { Typography, Grid, CircularProgress } from '@material-ui/core'
import { LabelStyle } from '../../../theme/Forms'
import { theme } from '../../../theme/Global'

export const NotificationsSettings = styled(Typography)`
  &&& {
    color: ${theme.colors.text};
    border-bottom: 1px solid ${theme.colors.divider};
    padding-bottom: 2.25rem;
  }
`

export const StyledContainer = styled.div`
  &&& {
    margin: 80px auto;
  }
`

export const StyledForm = styled.form`
  &&& {
    margin-top: 45px;
  }
`

export const PaddedBarWrapper = styled(Grid)`
  &&& {
    margin-top: 2.5rem;
    border-top: 1px solid ${theme.colors.divider};
    border-bottom: 1px solid ${theme.colors.divider};
  }
`

export const SaveWrapper = styled(Grid)`
  &&& {
    margin: 4rem 0;
  }
`

export const Loading = styled(CircularProgress)`
  &&& {
    margin-left: 10px;
  }
`
export const PaddedLabelStyle = styled(LabelStyle)`
  &&& {
    padding: 0.7rem;
  }
`
